import React from "react";
import { Link } from "react-router-dom";
import "../../styles/PaidServices.css";

const SubscriptionSuccess = () => {
  return (
    <div className="cancel-container">
      <div>
        <div className="header">
          <Link to="/paidservices" className="back-link-cont">
            ←
          </Link>
          <p className="settings-title-cont">解約ページ</p>
        </div>
        <h3>有料プランの加入が完了しました</h3>
        <div className="cancel-content">
          <p className="cancel-description">
            有料プランのご利用ありがとうございました。また、ご利用ください。
          </p>
        </div>
      </div>
  </div>
  );
};

export default SubscriptionSuccess;
